module.exports = __webpack_public_path__ + "static/img/01.381f38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pomelo/01.png
// module id = FQSo
// module chunks = 6